module.exports = __webpack_public_path__ + "img/0-02.4a8316cc.jpg";